import { render, staticRenderFns } from "./PageHomeBed.vue?vue&type=template&id=5980a8c1&scoped=true&"
import script from "./PageHomeBed.vue?vue&type=script&lang=js&"
export * from "./PageHomeBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980a8c1",
  null
  
)

export default component.exports